import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { propTypes as reduxFormPropTypes, reduxForm } from 'redux-form';
import EditSelectionForm from '../../common/components/EditSelectionForm';

const validate = (values, props) => {
  const errors = {};
  const field = 'name';

  if (props.checkedMailProcessingCenters && !props.checkedMailProcessingCenters.length) {
    errors[field] = (
      <div id="no-impcs-selected">
        <FormattedMessage id="app.no.impcs.selected" />
      </div>
    );
  }

  return errors;
};

// eslint-disable-next-line react/prefer-stateless-function
class EditIMPCSelectionFormContainer extends Component {
  render() {
    const {
      onCloseModal,
      handleSubmit,
      name,
      errorMessage,
    } = this.props;

    return (<EditSelectionForm
      onCloseModal={onCloseModal}
      handleSubmit={handleSubmit}
      errorMessage={errorMessage}
      name={name}
    />);
  }
}

EditIMPCSelectionFormContainer.propTypes = {
  ...reduxFormPropTypes,
  onCloseModal: PropTypes.func.isRequired,
  name: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default reduxForm({
  form: 'saveSelection',
  validate,
})(EditIMPCSelectionFormContainer);
